import { render, staticRenderFns } from "./RightStock.vue?vue&type=template&id=0b6f55e6&scoped=true&"
import script from "./RightStock.vue?vue&type=script&lang=js&"
export * from "./RightStock.vue?vue&type=script&lang=js&"
import style0 from "./RightStock.vue?vue&type=style&index=0&id=0b6f55e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6f55e6",
  null
  
)

export default component.exports